<template>
  <div>
    <b-modal ref="mdlImpegnativa" :title="'Impegnativa'" @shown="onShown" size="xl"
      style="height: 100%; max-height: 100%; width: 80%; max-width: 80%" centered scrollable footer-tag="footer"
      no-close-on-backdrop :no-close-on-esc="noCloseOnEsc" :hide-header-close="hideHeaderClose">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 2rem">

        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 1 </span>
            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Informazioni Ricetta</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <label class="sa-label-data">Numero Impegnativa (NRE)</label>
          090880818190000
          <b-row>
            <b-col cols="4" xs="12" sm="12" md="12" lg="4" xl="4"> <b-form-input :disabled="!isEdit"
                v-model="localData.codiceBar1" class="text-upper" placeholder="Primi 5 Caratteri"
                maxlength="5"></b-form-input></b-col>
            <b-col cols="6" xs="12" sm="12" md="12" lg="6" xl="6"> <b-form-input :disabled="!isEdit"
                v-model="localData.codiceBar2" class="text-upper" placeholder="Successivi 10 Caratteri"
                maxlength="10"></b-form-input></b-col>
            <b-col cols="2" xs="12" sm="12" md="12" lg="2" xl="2">
              <button type="button" @click="onRicercaAssistito" class="sa-ft-action-btn primary">
                <span>Ricerca</span>
                <small>🔍</small>
              </button>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Tipologia Ricetta</label>
          <b-form-select v-model="localData.tipologiaRicetta" :options="tipologiaRicettaOptions" value-field="value"
            text-field="text" :disabled="!isEdit || isDematerializzata" @change="onChangeTipologia">
            <template #first>
              <b-form-select-option disabled :value="null">Seleziona</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Priorità</label>
          <b-form-select id="inline-form-custom-select-pref" v-model="localData.classePriorita"
            class="mb-2 mr-sm-2 mb-sm-0" :disabled="!isEdit || isDematerializzata" :options="prioritaOptions"
            :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>

        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Codice Fiscale Assisito</label>
          <b-form-input :disabled="false" class="text-upper" v-model="localData.codiceFiscaleAssistito"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Data Prescrizione</label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="localData.dataPrescrizione"
            :disabled="!isEdit || isDematerializzata" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Diagnosi codificata</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="localData.descrizioneDiagnosi" value="descrizioneDiagnosi"
              :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!isEdit" @click="onClickBtnRicercaIcdIx(1)" variant="outline-info"><font-awesome-icon
                  icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Codice Esenzione</label>
          <b-input-group class="mt-3">
            <b-form-input v-model="localData.codiceEsenzione" :disabled="true"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!isEdit || isDematerializzata" @click="onClickBtnRicercaCodiciEsenzione()"
                variant="outline-info"><font-awesome-icon icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Non Esente</label>
          <b-form-checkbox switch v-model="localData.nonEsente"
            :disabled="!isEdit || blockEsenzione || isDematerializzata"></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Reddito</label>
          <b-form-checkbox switch v-model="localData.esenteReddito"
            :disabled="!isEdit || blockEsenzione || isDematerializzata"></b-form-checkbox>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 2 </span>

            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Informazioni Medico Prescrittore</span></h5>
          </div>

          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <div role="regioneResidenzainput">
            <label class="sa-label-data">Regione</label>
            <b-form-select id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0" :value="null"
              :disabled="!isEdit" v-model="localData.presRegione" value-field="codiceIstat"
              :state="getStateValidationField('presRegione')" text-field="regione" :options="regioniOptions" required>
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("presRegione") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <label class="sa-label-data">Matricola</label>
          <b-input-group class="mt-3">
            <b-form-input :disabled="!isEdit" class="text-upper" v-model="localData.matricola"></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-info" @click="onClickSelezionaMedico()" :disabled="!isEdit"><font-awesome-icon
                  icon="search" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Cognome</label>
          <b-form-input :disabled="!isEdit" class="text-upper" v-model="localData.presCognome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Nome</label>
          <b-form-input :disabled="!isEdit" class="text-upper" v-model="localData.presNome"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="2" xl="2">
          <label class="sa-label-data">Pres. Codice Fiscale</label>
          <b-form-input :disabled="!isEdit" class="text-upper" v-model="localData.presCodiceFiscale"></b-form-input>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="1" xl="1">
          <label class="sa-label-data">Pres. Tipo. </label>
          <b-form-select id="inline-form-custom-select-pref" v-model="localData.codiceSpecializzazioneMedico"
            class="mb-2 mr-sm-2 mb-sm-0" :disabled="!isEdit" :options="presTipologiaOptions" :value="null">
            <template #first>
              <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <div class="d-flex align-items-center mb-2 mt-2">
            <span class="badge rounded-circle d-flex align-items-center justify-content-center mr-2"
              style="width: 32px; height: 32px; background-color: #00a3ff; color: white; font-size: 14px"> 3 </span>
            <h5 class="mb-0" style="font-weight: 600; color: #333; letter-spacing: 0.5px"><span
                style="color: #00a3ff">Prestazioni</span></h5>
          </div>
          <hr class="mt-1 mb-3" style="border-top: 2px solid; opacity: 0.5; width: 60%" />
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">

          <AccettazioneSsnPrestazioniComponent @onAggiungiPrestazione="onAggiungiPrestazione"
            @updatePrestazioni="onUpdatePrestazioni" ref="cmpAccettazioneSsnPrestazioniComponent" />
        </b-col>
      </b-row>
      <template #modal-footer>
        <div class="d-flex justify-content-end w-100">
          <b-button size="sm" variant="danger" class="ml-2" v-if="btnAnnullaShow" @click="onAnnulla"> Annulla
          </b-button>
          <b-button v-if="!isModifica" size="sm" variant="success" class="ml-2" @click="onAggiungiImpegnativa"
            :disabled="isDisabledAggiungiImpegnativa"> Aggiungi Impegnativa </b-button>
          <b-button v-if="isModifica && id != '-1'" size="sm" variant="success" class="ml-2"
            @click="onModificaImpegnativa()" :disabled="isTastoModificaAttivo()"> Modifica Impegnativa </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal ref="mdlMedici" size="xl" title="Seleziona un Medico" @ok="confermaSelezioneMedico" ok-title="Conferma"
      cancel-title="Annulla">
      <b-form @submit.prevent="onRicercaMediciPrescrittori">
        <b-row>
          <b-col cols="4" class="my-1">
            <label for="input-1" class="sa-form-label">Nome Medico</label>
            <b-form-input id="input-1" v-model="filtroMediciPrescrittori.pres_nome" type="text"
              placeholder="Nome Medico Prescrittore"></b-form-input>
          </b-col>
          <b-col cols="4" class="my-1">
            <label for="input-2" class="sa-form-label">Cognome Medico</label>
            <b-form-input id="input-2" v-model="filtroMediciPrescrittori.pres_cognome" type="text"
              placeholder="Cognome Medico Prescrittore"></b-form-input>
          </b-col>
          <b-col cols="4" class="my-1">
            <label for="input-2" class="sa-form-label">Matricola</label>
            <b-form-input id="input-2" v-model="filtroMediciPrescrittori.matricola" type="text"
              placeholder="Matricola Medico Prescrittore"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <b-table selectable select-mode="single" :items="medici" :fields="fieldsMedici" responsive striped hover
        @ok="confermaSelezioneMedico" @row-selected="onRowSelected">
        <template #cell(nome)="row">
          <span>{{ row.item.nome }} {{ row.item.cognome }}</span>
        </template>
      </b-table>
    </b-modal>
    <b-modal ref="mdlCodiciIcdIx" id="mdlCodiciIcdIx" title="CODICI ICD-IX" size="xl" @ok="onOkMdlCodiciIcdIx">
      <b-form @submit.prevent="onRicercaCodiceIcdx">
        <b-row>
          <b-col cols="6" class="my-1">
            <label for="input-1" class="sa-form-label">Codice IcdIX</label>
            <b-form-input id="input-1" v-model="filtroIcdix.codice" type="text"
              placeholder="Codice IcdIX"></b-form-input>
          </b-col>
          <b-col cols="6" class="my-1">
            <label for="input-2" class="sa-form-label">Descrizione Codice IcdIX</label>
            <b-form-input id="input-2" v-model="filtroIcdix.descrizione" type="text"
              placeholder="Descrizione Codice IcdIX"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <div style="max-height: 200px; overflow-y: scroll">
        <b-table ref="table" sticky-header responsive stacked="lg" striped hover selectable select-mode="single"
          :items="itemsIcdix" :fields="fieldsiCDX" :current-page="1" :per-page="1000" @ok="onOkMdlCodiciIcdIx"
          @row-selected="setRowSelected" sort-icon-left head-variant="light" class="sa-b-table">
        </b-table>
      </div>
    </b-modal>
    <b-modal ref="mdlCodiciEsenzione" id="mdlCodiciEsenzione" title="CODICI ESENZIONE" size="xl"
      @ok="onOkMdlCodiciEsenzione">
      <b-form @submit.prevent="onRicercaCodiciEsenzioni">
        <b-row>
          <b-col cols="6" class="my-1">
            <label for="input-1" class="sa-form-label">Codice</label>
            <b-form-input id="input-1" v-model="filtroCodiciEsenzione.codice" type="text"
              placeholder="Codice"></b-form-input>
          </b-col>
          <b-col cols="6" class="my-1">
            <label for="input-2" class="sa-form-label">Descrizione</label>
            <b-form-input id="input-2" v-model="filtroCodiciEsenzione.descrizione" type="text"
              placeholder="Descrizione"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="primary">Cerca</b-button>
          </b-col>
        </b-row>
      </b-form>
      <div style="max-height: 200px; overflow-y: scroll">
        <b-table ref="table" sticky-header responsive stacked="lg" striped hover selectable select-mode="single"
          :items="itemsCodiceEsenzione" :fields="fieldsCodice" :current-page="1" :per-page="1000"
          @ok="onOkMdlCodiciIcdIx" @row-selected="setCodiceEsenzioneSelected" sort-icon-left head-variant="light"
          class="sa-b-table">
        </b-table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import AccettazioneSsnPrestazioniComponent from "../../ssn/components/AccettazioneSsnPrestazioniComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import toast from "../../../../template/layout/utility/sa-toast.js";
export default {
  mixin: [UtilityMixin],
  components: { AccettazioneSsnPrestazioniComponent, DatePicker },
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  props: {
    isEdit: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    hideHeaderClose: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
    codiceFiscalePaziente: {
      type: String,
      require: false,
      default: () => {
        return null;
      },
    },
    noCloseOnEsc: {
      type: Boolean,
      require: false,
      default: () => {
        return true;
      },
    },
    btnAnnullaShow: {
      type: Boolean,
      require: false,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      id: null,
      accettazioneJson: {},
      isDematerializzata: false,
      rowSelected: null,
      pathResourceICDIX: "/serviziicdix",
      pathResourceCodiceEsenzione: "/codiceesenzione",
      isModifica: false,
      isNuovoRecord: false,
      pathResource: "/accettazionericette",
      filtroMediciPrescrittori: {},
      form: "",
      medici: [],
      filtroCodiciEsenzione: {
        codice: null,
        descrizione: null,
      },
      fieldsCodice: [
        {
          label: "Codice Esenzione",
          key: "codice",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
        {
          label: "Descrizione",
          key: "descrizione",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
      ],
      fieldsiCDX: [
        {
          label: "Codice IcDx",
          key: "codiceIcdix",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
        {
          label: "Descrizione IcDx",
          key: "descrizioneIcdix",
          thStyle: "width: 15rem text-center",
          tdStyle: "text-center",
          sortable: true,
        },
      ],
      fieldsMedici: [
        {
          field: "matricola",
          label: "Matricola",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "nome",
          label: "Nome",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "codiceFiscale",
          label: "Codice Fiscale",
          type: "string",
          sortable: false,
          filterable: true,
        },
        {
          field: "tipologia",
          label: "Tipologia",
          type: "string",
          sortable: true,
          filterable: true,
        },
        {
          field: "regione",
          label: "Regione",
          type: "string",
          sortable: true,
          filterable: true,
        },
      ],
      rigaSelezionataDiagnosiIndex: null,
      regioniOptions: [],
      rules: {
        presRegione: {
          msg: "Regione Prescrittore non valido",
          rule: (val) => val != null,
        },
      },
      itemsIcdix: [],

      filtroIcdix: {
        codiceIcdix: null,
        descrizioneIcdix: null,
      },
      blockEsenzione: false,
      presidio: { codiceStruttura: null },
      localData: {
        tipologiaRicetta: null,
        codiceFiscaleAssistito: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        codiceBar1: null,
        statoAttuale: "PRESA IN CARICO",
        codiceBar2: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: true,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        cfMedico: null,
        prestazioni: [],
        _showDetails: false,
      },
      jsonDataIntegrazione: {},
      itemsCodiceEsenzione: [],
      indexRowSelected: null,
      rigaSelezionataDiagnosi: [],
      rigaSelezionataCodice: [],
      indexSelezionato: 1,
      presRegioniOptions: [],
      tipologiaRicettaOptions: [
        { text: "CONV", value: "CONV" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
      presTipologiaOptions: ["SPEC(SUMAI)", "DIP.ASL", "MMG", "GM", "OSP", "PEDIATRA", "GMTURISTICA", "MOSP-UNIV", "ALTRO"],
      prioritaOptions: ["U", "B", "D", "P"],
    };
  },
  mounted() {
    let me = this;
    me.loadRegioni();
    me.setComponentChild();
    this.id = this.$route.params.id;
    me.localData.codiceFiscaleAssistito = me.codiceFiscalePaziente;
    let tmpPresidio = window.localStorage.getItem("presidio");
    if (tmpPresidio) {
      let presidio = JSON.parse(tmpPresidio);
      this.presidio = presidio;
    }
  },
  computed: {
    isDisabledAggiungiImpegnativa() {
      let me = this;
      if (me.localData.tipologiaRicetta == null) {
        return true;
      } else {
        if (me.localData.tipologiaRicetta === "PRIVATA" && me.localData.classePriorita != null) {
          return false;
        }
      }
      if (me.localData.codiceBar1 == null || me.localData.codiceBar1 === "") {
        return true;
      }
      if (me.localData.codiceBar2 == null || me.localData.codiceBar2 === "") {
        return true;
      }

      return false;
    },
  },
  methods: {
    init(jsonData) {
      let me = this;

      this.accettazioneJson = jsonData;
      me.localData = {
        tipologiaRicetta: me.localData.tipologiaRicetta,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        statoAttuale: "PRESA IN CARICO",
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        codiceFiscaleAssistito: jsonData.accettazioneAnagrafica.identificativo,
        prestazioni: [],
      };

      this.isNuovoRecord = true;
      this.show();
    },
    onShown() {
      console.log(this.accettazioneJson);
      console.log(this.localData);

      this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
    },
    show() {
      this.$refs.mdlImpegnativa.show();
    },
    showDematerializzata(accettazione) {
      this.isDematerializzata = true;
      this.init(accettazione.accettazione);
    },
    hide() {
      this.$refs.mdlImpegnativa.hide();
    },
    onRicercaAssistito() {
      if (this.localData.codiceBar1 == null || this.localData.codiceBar1.trim() == "") {
        if (this.localData.codiceBar2 == null || this.localData.codiceBar2.trim() == "") {
          toast.error("Inserire NRE valido !")
          this.closeShowModalLoading();
          return;
        }
        toast.error("Inserire NRE valido !")
        this.closeShowModalLoading();
        return
      }
      this.openShowModalLoading();
      let filter = {
        nre: this.localData.codiceBar1 + this.localData.codiceBar2
      }
      let link = process.env.VUE_APP_PATH_API + "/saccsarrlazio/integrazionenre/" + this.presidio.codiceStruttura;
      axios.get(link, { params: filter }).then((response) => {
        this.jsonDataIntegrazione = response.data.data;
        this.localData = response.data.data.ricette[0];
        this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.jsonDataIntegrazione);
        toast.success("Recupero dati effettuato con successo")
        this.closeShowModalLoading();
      }).catch((err) => {
        toast.error(err.response.data.messaggio)
        this.closeShowModalLoading();
      });
    },

    onUpdatePrestazioni(prestazioni) {
      this.localData.prestazioni = prestazioni;
      this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
    },
    onAggiungiPrestazione(row) {
      delete row.item.new;
      this.localData.prestazioni.push(JSON.parse(JSON.stringify(row.item)));
      this.$refs.cmpAccettazioneSsnPrestazioniComponent.init(this.localData, this.accettazioneJson);
    },
    onRicercaCodiciEsenzioni() {
      let me = this;
      me.loadCodiciEsenzione();
    },

    loadCodiciEsenzione() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceCodiceEsenzione + "?forPage=" + 1000 + "&page=" + 1;
      axios
        .get(link, { params: this.filtroCodiciEsenzione })
        .then((response) => {
          me.itemsCodiceEsenzione = [];
          me.itemsCodiceEsenzione = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    loadCodiciIcdix() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceICDIX + "?forPage=" + 1000 + "&page=" + 1;
      //   + "&codiceIcdix=" + me.jsonData.codiceIcdix + "&descrizioneIcdix=" + me.jsonData.descrizioneIcdix;
      axios
        .get(link, { params: this.filtroIcdix })
        .then((response) => {
          me.itemsIcdix = [];
          me.itemsIcdix = response.data.data.list;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    loadMediciPrescrittori() {
      let me = this;
      me.showModalLoading = true;
      let link = process.env.VUE_APP_PATH_API + "/accettazionericette/mediciprescrittori";
      axios
        .get(link, { params: this.filtroMediciPrescrittori })
        .then((response) => {
          me.medici = [];
          me.medici = response.data.data;
          me.showModalLoading = false;
        })
        .catch(() => {
          me.showModalLoading = false;
        });
    },
    setRicettaModificare(json) {
      let me = this;
      me.indexRowSelected = json.index;
      me.localData = JSON.parse(JSON.stringify(json.item));
      me.loadCodiciIcdix();
      me.loadCodiciEsenzione();
      me.isModifica = true;

    },
    setRowSelected(row) {
      let me = this;
      me.rigaSelezionataDiagnosi = row;
    },
    setCodiceEsenzioneSelected(row) {
      let me = this;
      me.rigaSelezionataCodice = row;
    },

    onRicercaMediciPrescrittori() {
      let me = this;
      me.loadMediciPrescrittori();
    },
    onModificaImpegnativa() {
      let me = this;
      this.$emit("onModificaImpegnativa", me.localData, me.indexRowSelected);
      me.isModifica = false;
      me.hide();
    },

    onRicercaCodiceIcdx() {
      let me = this;
      me.loadCodiciIcdix();
    },
    onOkMdlCodiciEsenzione() {
      let me = this;
      me.localData.codiceEsenzione = me.rigaSelezionataCodice[0].codice;
      me.localData.nonEsente = false;
      me.blockEsenzione = true;
    },
    onOkMdlCodiciIcdIx() {
      let me = this;
      switch (me.indexSelezionato) {
        case 1:
          me.localData.codiceDiagnosi = me.rigaSelezionataDiagnosi[0].codiceIcdix;
          me.localData.descrizioneDiagnosi = me.rigaSelezionataDiagnosi[0].descrizioneIcdix;
          break;
      }
    },
    isTastoModificaAttivo() {
      let me = this;
      //verificare se presente prestazione con stato EROGATO
      return !me.isEdit;
    },
    onClickBtnRicercaIcdIx(index) {
      let me = this;
      me.rigaSelezionataDiagnosi = index;
      this.$refs.mdlCodiciIcdIx.show();
    },
    onClickBtnRicercaCodiciEsenzione(index) {
      let me = this;
      me.rigaSelezionataDiagnosiIndex = index;
      this.$refs.mdlCodiciEsenzione.show();
    },
    onClickSelezionaMedico() {
      this.$refs.mdlMedici.show();
    },
    setComponentChild() {
      let me = this;
      me.edit(me.jsonData);
    },
    edit(jsonData) {
      let me = this;
      me.localData = { ...me.localData, ...jsonData };
    },
    getStateValidationField(fieldName) {
      let me = this;
      const field = me.localData[fieldName];
      if (field === null) {
        return null;
      }
      const rules = me.rules[fieldName];
      if (!rules) {
        return true;
      }
      return rules.rule(field);
    },

    getMsg(fieldName) {
      let me = this;
      const fieldValue = me.localData[fieldName];
      const valid = me.getStateValidationField(fieldName);
      const rules = me.rules[fieldName];
      if ((fieldValue && !valid) || fieldValue == null) {
        if (rules) return rules.msg;
      }
      return null;
    },

    onRowSelected(row) {
      let me = this;
      me.rowSelected = row;
    },
    onChangeTipologia(tipo) {
      let me = this;
      if (!this.localData.id || this.localData.id == "-1") {
        if (tipo === "PRIVATA") {
          me.localData.codiceBar1 = "PVT";
          me.localData.codiceBar2 = crypto.randomUUID().substring(0, 5);
        } else {
          me.localData.codiceBar1 = "";
          me.localData.codiceBar2 = "";
        }
        if (tipo === "DEMATERIALIZZATA") {
          me.localData = {
            tipologiaRicetta: me.localData.tipologiaRicetta,
            dataPrescrizione: new Date().getTime(),
            dataInizioErogazione: new Date().getTime(),
            dataFineErogazione: new Date().getTime(),
            presRegione: null,
            matricola: null,
            presCognome: null,
            statoAttuale: me.localData.statoAttuale,
            presNome: null,
            presCodiceFiscale: null,
            codiceSpecializzazioneMedico: null,
            descrizioneDiagnosi: null,
            nonEsente: false,
            esenteReddito: false,
            codiceEsenzione: null,
            classePriorita: null,
            codiceFiscaleAssistito: me.localData.codiceFiscaleAssistito,
            prestazioni: [],
          };
        }
      }
      this.$emit("onChangeTipologiaRicetta", tipo);
    },
    confermaSelezioneMedico() {
      let me = this;
      let json = me.rowSelected[0];
      me.localData.matricola = json.matricola;
      me.localData.presNome = json.nome;
      me.localData.presCognome = json.cognome;
      me.localData.presCodiceFiscale = json.codiceFiscale;
      me.localData.codiceSpecializzazioneMedico = json.tipologia;
      me.localData.presRegione = json.regione;
      me.localData.cfMedico = json.codiceFiscale;
    },

    onAnnulla() {
      let me = this;
      //UtilityMixin.methods.restCallPost("/pathResource",{},me.callBackOnAggiungiImpegnativaSuccess,me.callBackOnAggiungiImpegnativaError)
      me.$emit("onAnnulla", {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        statoAttuale: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        priorita: null,
        cfMedico: null,
        prestazioni: [],
      });
      me.hide();
    },
    onAggiungiImpegnativa() {
      let me = this;
      //POST CALLER
      console.log("aggiungo impegnativa", me.localData, this.jsonDataIntegrazione);

      me.$emit("onAggiungiImpegnativa", me.localData, this.jsonDataIntegrazione);
      me.hide();
      me.localData = {
        tipologiaRicetta: null,
        dataPrescrizione: new Date().getTime(),
        dataInizioErogazione: new Date().getTime(),
        dataFineErogazione: new Date().getTime(),
        presRegione: null,
        matricola: null,
        presCognome: null,
        statoAttuale: null,
        presNome: null,
        presCodiceFiscale: null,
        codiceSpecializzazioneMedico: null,
        descrizioneDiagnosi: null,
        nonEsente: false,
        esenteReddito: false,
        codiceEsenzione: null,
        classePriorita: null,
        prestazioni: [],
      };
    },
    loadRegioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/regioni";
      axios.get(link).then((response) => {
        response.data.data.forEach((regione) => {
          me.regioniOptions.push(regione);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
